import { EmbedPbiInfo, ReportForUser } from "./types";
import { getAccessToken } from "../../services/msalService";
import { resetInactivityTimer } from "../../services/inactivityTimer";
import { handleResponse, handleError, fetchWithAccessToken } from "../../services/apiUtils";

export const getReportsForUsers = async (): Promise<ReportForUser[]> => {
        return await fetchWithAccessToken("/api/embedpbi/GetPbiReportsInfoForUserAsync");
}

export const getEmbedInfo = async (workspaceId: string, reportId: string): Promise<ReportForUser[]> => {
    const reportParams = {
        "workspaceId": workspaceId,
        "reportId": reportId
    }
    resetInactivityTimer();
    const accessToken = await getAccessToken();
    return await fetch("/api/embedpbi/GetPbiEmbedInfoAsync",
        {
            body : JSON.stringify(reportParams),
            method : "GET",
            headers : { 'Content-Type' : 'application/json', Authorization : `Bearer ${accessToken}` },

        }).then(response => response.json())
        .then(response => response);
};


export const getEmbedInfoForReport = async (workspaceId: string, reportId: string): Promise<ReportForUser[]> => {
    const reportParams = {
            "workspaceId": workspaceId,
            "reportId": reportId
        }
    resetInactivityTimer();
    const accessToken = await getAccessToken();
    return await fetch("/api/embedpbi/GetPbiEmbedInfoForUserAsync",
            {
                body: JSON.stringify(reportParams),
                method: "POST",
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },

            }).then(response => response.json())
        .then(response => response);
};